// Batch 27 · Add-on 2 Step 2 (owner, 16-Oct-2026) — Sampling → Continuous testing: the three Analytics rule counts are a
// stored result. This shows its banner (shared StoredResultBanner) and runs / reruns it as a background job on the user's
// click; the counts are never computed on open. Sampling.jsx is over 1,500 lines (big-file rule), so it lives here.
import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import api, { toErrMsg } from "@/lib/api";
import { useI18n } from "@/contexts/I18nContext";
import { waitForJob } from "@/lib/waitJob";
import StoredResultBanner from "@/components/StoredResultBanner";
import TbOnlyNotice from "@/components/TbOnlyNotice";   // PR 3 · rule 1 (B-1a): the rules flag journal lines
import { jobErrorText } from "@/lib/jobErrorText";   // Step 11d · A2: a failed job's error in the screen's language

export default function ContinuousRulesRun({ engId, lang = "en", stored, status, onDone }) {
  const { t } = useI18n();
  const [running, setRunning] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const alive = useRef(true);
  useEffect(() => () => { alive.current = false; }, []);

  const follow = async (jobId) => {
    setRunning(true); setError("");
    const j = await waitForJob(jobId, { onProgress: (p, m) => { if (alive.current) { setProgress(p); setMessage(m); } } });
    if (!alive.current) return;
    setRunning(false);
    if (j?.status === "failed") setError(jobErrorText(j, lang, t));
    onDone && onDone();
  };
  // a run already going (another tab, or started before a reload) is followed too
  useEffect(() => {
    const jid = stored?.job?.id;
    if (stored?.running && jid && !running) follow(jid);
    // eslint-disable-next-line
  }, [stored?.job?.id]);

  const run = async () => {
    try {
      const r = await api.post(`/samples/continuous-rules/${engId}/rescan`);
      await follow(r.data.job_id);
    } catch (e) { toast.error(toErrMsg(e, "Failed")); setRunning(false); }
  };
  return (
    <>
      <StoredResultBanner lang={lang} state={stored?.state || "not_run"} runAt={stored?.run_at} runBy={stored?.run_by_name}
                          running={running} progress={progress} message={message} error={error} onRun={run}
                          testid="continuous-rules-banner" />
      <TbOnlyNotice status={status} testid="continuous-rules-tb-only" />
    </>
  );
}
